export class InvoicingControlViewModel {
	constructor(
		public Id: number,
		public TableId: number,
		public Name: string,
		public RecordsAmount: number) {
	}
}